module.exports = __webpack_public_path__ + "img/Objetivo 1.b0ef24b5.png";